
import { Component, Vue, Prop } from 'vue-property-decorator'
import i18n from '@/i18n'
import axios from 'axios'
import RedCooperationUtils from '@/utilsTenant/RedCooperationUtils'
import { isDev } from '@/utils/utils'

@Component({
  i18n,
  components: {}
})
export default class TeaserSitecore extends Vue {
  @Prop({ default: 'teaser1' }) public jsonFileName!: string
  private hasHover = false
  private disableStyles = false
  private loaded = false

  private jsonTeaserRemote: {
    tag: string
    imageUrl: string
    imageBackground: string
    buttonUrl: string
    buttonText: string
    target: string // '_self' | '_parent' | '_blank' | '_top'
    ctaSecondary: boolean
    headerText: string
    teaserContent: string
    contentBackground: string
    redCooperationPartner: boolean
    hide: boolean
  } = {
    tag: '',
    imageUrl: '',
    imageBackground: '',
    buttonUrl: '',
    buttonText: '',
    target: '_blank',
    ctaSecondary: true,
    headerText: '',
    teaserContent: '',
    contentBackground: '',
    redCooperationPartner: true,
    hide: false
  }

  private teaserNotFound = {
    imageUrl: '/dacp/-/media/project/dadirekt/website/error-wartung/404-fehlerseite.png?extension=webp&t=1603882147',
    tag: 'Teaser',
    imageBackground: '#fff2ee',
    headerText: 'Teaser not found',
    teaserContent: 'We are very sorry but the teaser requested was not found.',
    buttonUrl: 'https://da-direkt.de',
    buttonText: 'DA Direkt',
    target: '_blank',
    ctaSecondary: false,
    contentBackground: '',
    redCooperationPartner: false,
    hide: false
  }

  public redirect(url: string): void {
    const target = this.jsonTeaserRemote.target
    if (!url || url === '') {
      throw new Error('Url path is not available!')
    }
    if (target !== '_self' && target !== '_parent' && target !== '_blank' && target !== '_top') {
      window.open(url, '_blank')
    } else if (target === '_self' || target === '_parent' || target === '_blank' || target === '_top') {
      window.open(url, this.jsonTeaserRemote.target)
    }
  }

  get isRedCooperationPartner(): boolean {
    return RedCooperationUtils.isRedCooperationPartner()
  }

  get showTeaser(): boolean {
    if (this.jsonTeaserRemote.hide || !this.loaded) return false
    // jsonTeaserRemote.redCooperationPartner: if true then hide teaser when partner is a red cooperation partner
    if (this.isRedCooperationPartner && this.jsonTeaserRemote.redCooperationPartner) return false
    return true
  }

  public async mounted(): Promise<void> {
    this.$nextTick(async function () {
      try {
        if (isDev()) {
          this.jsonTeaserRemote = {
            ...this.teaserNotFound,
            headerText: 'Mock Teaser',
            teaserContent: 'DEV Mock Teaser'
          }
        } else {
          const response = await axios.get(
            `${window.location.origin ?? 'https://da-direkt.de'}/dacp/${this.jsonFileName}.json`,
            {}
          )
          this.jsonTeaserRemote = response.data
        }
        this.loaded = true
      } catch {
        this.jsonTeaserRemote = this.teaserNotFound
        // Catch must be defined
      }
    })
  }
}
